import { useSelector } from 'react-redux'
import FreebetBettingCard from './FreebetBettingCard'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import { useFreebetsSync } from '@hooks/betting/useFreebetsSync'
import { useFreebetSelectionRequest } from '@hooks/betting/useFreebetSelectionRequest'
import { PANELS } from '@constants/bettingConstants'

const FreebetsBettingController = () => {
  // The single place the server freebet list is mirrored into the store. Mounted
  // here (not per-card) so both panels read one reconciled source of truth.
  const { isLoading } = useFreebetsSync()
  // Consume a menu "Play" request (select it on panel one once the list has it).
  useFreebetSelectionRequest()

  const { freebets, divider } = useSelector((state) => state.layout.duelBetMode)

  // Initial freebet fetch (first time the tab opens) — show a loader until the
  // list arrives, rather than flashing empty/placeholder cards.
  if (isLoading) {
    return (
      <div className="standard-normal-freebets-betting-controller-outer-container">
        <div className="standard-normal-freebets-betting-controller-loader">
          <SpinningLoader />
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-freebets-betting-controller-outer-container">
      <div className="standard-normal-freebets-betting-controller-inner-container">
        <div className="standard-normal-freebets-betting-card">
          <FreebetBettingCard panel={PANELS.ONE} />
        </div>
        {divider && <div className="standard-normal-freebets-betting-controller-divider" />}
        {freebets && (
          <div className="standard-normal-freebets-betting-card">
            <FreebetBettingCard panel={PANELS.TWO} />
          </div>
        )}
      </div>
    </div>
  )
}
export default FreebetsBettingController
